module.exports = __webpack_public_path__ + "media/images/icons/pictures-3ca4f2b12586518a3cfa5300129b93d4.png";